// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app"
import {
  getAnalytics,
  setUserProperties,
  type Analytics,
} from "firebase/analytics"
import packageJson from "../package.json"

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCm-HUgksHM9N19pFB-FapY7rPbv278DvU",
  authDomain: "the-conjunction.firebaseapp.com",
  projectId: "the-conjunction",
  storageBucket: "the-conjunction.firebasestorage.app",
  messagingSenderId: "256280800832",
  appId: "1:256280800832:web:5f7be61c6cc245940379a5",
  measurementId: "G-YPPQDZDC7J",
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// App version from package.json
const APP_VERSION = packageJson.version

// Initialize Analytics (only in browser environment)
let analytics: Analytics | undefined
if (typeof window !== "undefined") {
  analytics = getAnalytics(app)

  // Set app version as user property for Firebase reporting
  setUserProperties(analytics, {
    app_version: APP_VERSION,
    app_name: "Conjunction1",
  })
}

export { app, analytics, APP_VERSION }
